import React from 'react';
import { useLocale } from 'hooks';
import { Container, Typography } from '@material-ui/core';

import { DesktopPage, TabMenu } from 'ui';

import { useStyles } from './DesktopDahsboardGrid.styles';
import { BatteryListContainer } from './batteryList/BatteryListContainer';
import { UsageReportContainer } from './usageReport/UsageReportContainer';

export const DesktopDashboardGrid = () => {
  const classes = useStyles();
  const { formatMessage } = useLocale();

  return (
    <>
      <DesktopPage>
        <Container disableGutters>
          <div className={classes.textContainer}>
            <Typography className={classes.mainTitle}>{formatMessage({ id: 'navigation.batteries' })}</Typography>
            <Typography className={classes.subtitle}>{formatMessage({ id: 'navigation.home' })}</Typography>
            <Typography className={classes.subtitle}>|</Typography>
            <Typography className={classes.subtitle}>{formatMessage({ id: 'navigation.batteries' })}</Typography>
          </div>
          <TabMenu
            isFullScreen={false}
            activeColor="secondary"
            tabs={[
              {
                label: formatMessage({ id: 'batteries_desktop.list' }),
                content: <BatteryListContainer />,
              },
              {
                label: formatMessage({ id: 'batteries_desktop.usage_report' }),
                content: <UsageReportContainer />,
              },
            ]}
          />
        </Container>
      </DesktopPage>
    </>
  );
};
